import {
  HttpErrorResponse,
  HttpEvent,
  HttpInterceptorFn,
} from '@angular/common/http';

import { catchError, Observable, throwError } from 'rxjs';

export const csrfInterceptor: HttpInterceptorFn = (
  req,
  next,
): Observable<HttpEvent<unknown>> => {
  const getCookie = (name: string): string | null => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift() ?? null;
    }
    return null;
  };
  const csrftoken = getCookie('csrftoken');

  let newReq = req.clone({});

  if (csrftoken) {
    newReq = newReq.clone({
      headers: newReq.headers.set('X-CSRFToken', csrftoken),
    });
  }

  return next(newReq).pipe(
    // eslint-disable-next-line rxjs-x/no-implicit-any-catch
    catchError((error: HttpErrorResponse) => {
      console.error('Error in interceptor:', error);
      if (error.status === 401) {
        console.error('Unauthorized access');
      }
      return throwError(() => error);
    }), // Ensure the return type is correct
  );
};
